export default __webpack_public_path__ + "2f769f575eb60f0b2b790bbcbd693fe4.png";